var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('z-scroll',{attrs:{"options":{eventPassthrough:'vertical'},"direction":"horizontal"}},[_c('ul',{staticClass:"horizontal"},_vm._l((_vm.videoList.slice(0, 5)),function(item,index){return _c('li',{key:index,staticClass:"list-item"},[_c('video-show',{attrs:{"videoList":_vm.videoList,"selectedIndex":index,"video":item}})],1)}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }